export default __webpack_public_path__ + "static/media/330_dummy2016-ernaehrungsberatung.67f924ef.png";